import { createApp } from 'vue'
import AmountSelector from './AmountSelector'

const el = '.kb-component--amount-selector'

export default function (Store) {
    const DOM = document.querySelectorAll(el)
    if (DOM && DOM.length) {
        DOM.forEach((AmountSelectorDOM) => {
            const component = createApp(AmountSelector).use(Store)
            component.mount(AmountSelectorDOM)
        })
    }
}
